<template>
  <AppLayout>
    <div class="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 class="text-2xl font-bold move-text">Settings</h1>
        <p class="move-text-muted mt-1">Manage your Move preferences and workspace info.</p>
      </div>

      <section class="move-card p-6 space-y-4 text-left">
        <h2 class="text-lg font-bold move-text">Appearance</h2>
        <p class="text-sm move-text-muted">Choose light or dark mode. Your preference is saved on this device.</p>
        <div class="flex flex-wrap gap-3">
          <button
            type="button"
            class="move-btn-primary"
            :class="{ 'opacity-60': isDark }"
            @click="setTheme(false)"
          >
            <span class="material-icons text-lg">light_mode</span>
            Light
          </button>
          <button
            type="button"
            class="move-btn-primary"
            :class="{ 'opacity-60': !isDark }"
            @click="setTheme(true)"
          >
            <span class="material-icons text-lg">dark_mode</span>
            Dark
          </button>
        </div>
      </section>

      <section class="move-card p-6 space-y-3 text-left">
        <h2 class="text-lg font-bold move-text">Workspace</h2>
        <p class="text-sm move-text-muted">
          Move is connected to the Tiye API. User access is managed from the Users page.
        </p>
        <p class="text-sm move-text-faint">
          Signed in as {{ userEmail }} · Role: {{ moveRole }}
        </p>
      </section>
    </div>
  </AppLayout>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import AppLayout from '../layouts/AppLayout.vue'
import { useMoveTheme } from '../composables/useMoveTheme'

const store = useStore()
const { isDark, setTheme } = useMoveTheme()
const userEmail = computed(() => store.state.auth.user?.email || '')
const moveRole = computed(() => store.state.auth.moveProfile?.role || 'user')
</script>

<style scoped>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

.material-icons {
  font-family: 'Material Icons', sans-serif;
  font-weight: normal;
  font-style: normal;
  line-height: 1;
  display: inline-block;
}
</style>
